import { c as _c } from "react/compiler-runtime";
import { FaroChangeThumbnailDialog } from "@components/common/dialog/faro-change-thumbnail-dialog";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { selectedGroupSelector } from "@store/groups/groups-selector";
import { updateGroupDetails } from "@store/groups/groups-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { ImageEditIcon, Tooltip } from "@flat-ui";
import { ThumbnailSubjectType } from "@utils/thumbnail-utils";
import { ChangeGroupDetailsEvents } from "@utils/track-event/track-event-list";
import { useState } from "react";
import { PALETTE_VARS } from "@styles/palette-vars";
export function ChangeGroupThumbnailButton() {
  const $ = _c(7);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const selectedGroup = useAppSelector(selectedGroupSelector);
  const dispatch = useAppDispatch();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Tooltip component="div" title="Change thumbnail"><SphereIconButton component={ImageEditIcon} buttonSize="40px" iconSize="24px" color={PALETTE_VARS.text.primary} onClick={() => setIsDialogOpen(true)} /></Tooltip>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== dispatch || $[2] !== isDialogOpen || $[3] !== selectedGroup) {
    t1 = isDialogOpen && selectedGroup && <FaroChangeThumbnailDialog setIsDialogOpen={setIsDialogOpen} subjectId={selectedGroup?.id} subjectType={ThumbnailSubjectType.group} existingThumbnailUrl={selectedGroup.thumbnailUrl} onUpdateThumbnail={async thumbnailUrl => {
      await dispatch(updateGroupDetails({
        groupId: selectedGroup.id,
        payload: {
          imageUrl: thumbnailUrl
        }
      })).unwrap();
    }} eventName={ChangeGroupDetailsEvents.changeGroupThumbnail} />;
    $[1] = dispatch;
    $[2] = isDialogOpen;
    $[3] = selectedGroup;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}